import React from "react";
import { AddressSearchBottomSheet } from "./AddressSearchBottomSheet";
import { ConfirmAliasBottomSheet } from "./ConfirmAliasBottomSheet";
import { DifferentUtilityBottomSheet } from "./DifferentUtilityBottomSheet";
import { UnallowedAddressChangeSheet } from "./UnallowedAddressChangeSheet";
import { UtilityAccountNumberBottomSheet } from "./UtilityAccountNumberBottomSheet";
import type { UseServiceLocationSheets } from "./useServiceLocationSheets";

export type ServiceLocationSheetsProps = UseServiceLocationSheets & {
  /** Render the address list open (only used by stories) */
  forceOpen?: boolean;
};

/**
 * The sheets a customer can provide their service location through: address
 * search, ESI ID, and the alias and utility-change confirmations. Powered by
 * {@link useServiceLocationSheets}, whose result spreads into it.
 */
export const ServiceLocationSheets: React.FC<ServiceLocationSheetsProps> = ({
  addressSearch,
  uanSearch,
  activeSheet,
  pendingAddress,
  openSheet,
  closeSheet,
  selectResult,
  confirmAlias,
  confirmUtility,
  dismissConfirmation,
  addressSearchSheet,
  utilityAccountNumberSheet,
  forceOpen,
}) => {
  const openUtilityAccountNumber = utilityAccountNumberSheet
    ? () => {
        openSheet("uan");
      }
    : undefined;
  const openAddressSearch = addressSearchSheet
    ? () => {
        openSheet("address");
      }
    : undefined;

  return (
    <>
      {addressSearchSheet ? (
        <AddressSearchBottomSheet
          {...addressSearch}
          open={activeSheet === "address"}
          onClose={closeSheet}
          onSelect={selectResult}
          onNotFound={() => openUtilityAccountNumber?.()}
          onClickUtilityAccountNumber={openUtilityAccountNumber}
          forceOpen={forceOpen}
        />
      ) : null}
      {utilityAccountNumberSheet ? (
        <UtilityAccountNumberBottomSheet
          {...uanSearch}
          open={activeSheet === "uan"}
          onClose={closeSheet}
          onClickUseAddress={openAddressSearch}
        />
      ) : null}
      <ConfirmAliasBottomSheet
        open={activeSheet === "alias"}
        address={pendingAddress}
        onConfirm={confirmAlias}
        onClose={dismissConfirmation}
      />
      <DifferentUtilityBottomSheet
        open={activeSheet === "utility"}
        address={pendingAddress}
        onConfirm={confirmUtility}
        onClose={dismissConfirmation}
      />
      <UnallowedAddressChangeSheet
        open={activeSheet === "unallowed-address-change"}
        onClose={closeSheet}
      />
    </>
  );
};
